import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Box,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import rings from "../../assets/img/rings.png";

const Header: React.FC = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const menuItems = [
        { label: "Accueil", href: "/" },
        { label: "Programme", href: "/planning" },
       // { label: "RSVP", href: "/rsvp" },
        { label: "Venir", href: "/howtocome" },
        { label: "Loger", href: "/stay" },
        { label: "Visiter", href: "/visit" },
        { label: "Liste de mariage", href: "/wishlist" },
        { label: "FAQ", href: "/questions" },
    ];

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <Box
            sx={{
                width: 250,
                height: "100%",
                bgcolor: "background.paper",
                pt: 2,
            }}
            role="presentation"
            onClick={handleDrawerToggle}
        >
            <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2, pb: 1 }}>
                <IconButton onClick={handleDrawerToggle}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <List>
                {menuItems.map((item) => (
                    <ListItem key={item.label} disablePadding>
                        <ListItemButton
                            component="a"
                            href={item.href}
                            sx={{
                                textAlign: "center",
                                py: 2,
                                "&:hover": {
                                    bgcolor: "var(--green-3)",
                                    color: "#fff",
                                },
                            }}
                        >
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    textTransform: "uppercase",
                                    letterSpacing: "0.15em",
                                    fontWeight: "bold",
                                    fontSize: "0.9rem",
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <>
            <AppBar
                position="fixed"
                elevation={8}
                sx={{
                    boxShadow: "none",
                }}
            >
                <Toolbar sx={{ justifyContent: "center", position: "relative" }}>
                    {isMobile ? (
                        <>
                            {/* Bloc gauche : alliances + texte */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    position: "absolute",
                                    left: 16,
                                    gap: 1.5,
                                }}
                            >
                                <Box
                                    component="img"
                                    src={rings}
                                    alt="Alliances"
                                    sx={{
                                        height: 28,
                                        width: "auto",
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: "1.3rem",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Joseph et Salomé
                                </Typography>
                            </Box>

                            {/* Bouton menu à droite */}
                            <IconButton
                                color="inherit"
                                aria-label="ouvrir le menu"
                                edge="end"
                                onClick={handleDrawerToggle}
                                sx={{
                                    position: "absolute",
                                    right: 16,
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                        </>
                    ) : (
                        <Box
                            component="nav"
                            sx={{
                                display: "flex",
                                gap: 0,
                            }}
                        >
                            {menuItems.map((item) => (
                                <Box
                                    key={item.label}
                                    component="a"
                                    href={item.href}
                                    sx={{
                                        color: "#fff",
                                        textTransform: "uppercase",
                                        textDecoration: "none",
                                        letterSpacing: "0.15em",
                                        padding: "15px 20px",
                                        position: "relative",
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        fontFamily: "'Open Sans', arial, sans-serif",
                                        "&::after": {
                                            content: '""',
                                            position: "absolute",
                                            bottom: 0,
                                            left: "50%",
                                            width: 0,
                                            height: "2px",
                                            bgcolor: "var(--green-3)",
                                            transition: "width 0.3s ease, left 0.3s ease",
                                        },
                                        "&:hover::after": {
                                            width: "100%",
                                            left: 0,
                                        },
                                    }}
                                >
                                    {item.label}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Toolbar>
            </AppBar>

            <Drawer
                variant="temporary"
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Meilleure performance sur mobile
                }}
                sx={{
                    display: { xs: "block", md: "none" },
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: 250,
                    },
                }}
            >
                {drawer}
            </Drawer>
        </>
    );
};

export default Header;
